var _rect, _polygon, _path, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiChatbot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-38"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.98,
    y: 290.09,
    width: 75.81,
    height: 81.59,
    transform: "translate(617.77 661.77) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.41,
    y: 284.02,
    width: 9.53,
    height: 98.25,
    transform: "translate(528.35 666.29) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.51,
    y: 296.51,
    width: 6.21,
    height: 30.49,
    transform: "translate(663.23 623.52) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.76,
    y: 296.51,
    width: 6.21,
    height: 30.49,
    transform: "translate(611.73 623.52) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.3,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    transform: "translate(650.81 625.66) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.97,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    transform: "translate(624.15 625.66) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.18,
    y: 296.51,
    width: 4.01,
    height: 30.49,
    transform: "translate(634.37 623.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.19,
    y: 298.66,
    width: 3.11,
    height: 28.35,
    transform: "translate(641.49 625.66) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.55,
    y: 296.51,
    width: 6.21,
    height: 30.49,
    transform: "translate(599.3 623.52) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.34,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    transform: "translate(586.88 625.66) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    transform: "translate(560.22 625.66) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.22,
    y: 296.51,
    width: 4.01,
    height: 30.49,
    transform: "translate(570.44 623.52) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.23,
    y: 298.66,
    width: 3.11,
    height: 28.35,
    transform: "translate(577.56 625.66) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.9,
    y: 297.24,
    width: 3.11,
    height: 29.77,
    transform: "translate(550.9 624.24) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.9,
    y: 337.38,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.65,
    y: 337.38,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.11,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.44,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.43,
    y: 337.38,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.32,
    y: 339.52,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.86,
    y: 337.38,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.07,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.41,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.39,
    y: 337.38,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.72,
    y: 337.38,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.29,
    y: 339.52,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.62,
    y: 338.1,
    width: 3.11,
    height: 29.77,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,284v98.25h5.09v-5.5h75.28V284H268.82Zm5.09,48.1H344.4v35.75H273.91Zm0-39.21H344.4V327H273.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.91,
    y: 290.09,
    width: 75.81,
    height: 81.59,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.28,
    y: 375.77,
    width: 9.53,
    height: 6.5,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.47,
    y: 296.51,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.22,
    y: 296.51,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.68,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.01,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 296.51,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.89,
    y: 298.66,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.34,
    y: 296.51,
    width: 6.21,
    height: 30.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.55,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.88,
    y: 298.66,
    width: 6.21,
    height: 28.35,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.87,
    y: 296.51,
    width: 4.01,
    height: 30.49,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.76,
    y: 298.66,
    width: 3.11,
    height: 28.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.09,
    y: 297.24,
    width: 3.11,
    height: 29.77,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.9,
    y: 337.38,
    width: 6.21,
    height: 30.49,
    transform: "translate(812.02 705.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.15,
    y: 337.38,
    width: 6.21,
    height: 30.49,
    transform: "translate(760.51 705.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.69,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    transform: "translate(799.6 707.4) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.36,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    transform: "translate(772.93 707.4) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.57,
    y: 337.38,
    width: 4.01,
    height: 30.49,
    transform: "translate(783.16 705.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.59,
    y: 339.52,
    width: 3.11,
    height: 28.35,
    transform: "translate(790.28 707.4) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.03,
    y: 337.38,
    width: 6.21,
    height: 30.49,
    transform: "translate(756.28 705.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.82,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    transform: "translate(743.86 707.4) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.49,
    y: 339.52,
    width: 6.21,
    height: 28.35,
    transform: "translate(717.19 707.4) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.7,
    y: 337.38,
    width: 4.01,
    height: 30.49,
    transform: "translate(727.42 705.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.19,
    y: 337.38,
    width: 4.01,
    height: 30.49,
    transform: "translate(702.39 705.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.72,
    y: 339.52,
    width: 3.11,
    height: 28.35,
    transform: "translate(734.54 707.4) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.39,
    y: 338.1,
    width: 3.11,
    height: 29.77,
    transform: "translate(707.88 705.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.34,284H344.51v92.75H419.8v5.5h5.08V284Zm-2.54,83.85H349.31V332.12H419.8Zm0-40.83H349.31V292.91H419.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.61,
    y: 93.02,
    width: 143.13,
    height: 147.9,
    transform: "translate(688.36 333.94) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.61,
    y: 93.02,
    width: 143.13,
    height: 147.9,
    transform: "translate(678.36 333.94) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.41,
    y: 96.53,
    width: 135.73,
    height: 140.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 96.53,
    width: 132.34,
    height: 140.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.6,
    y: 96.53,
    width: 2.69,
    height: 140.95,
    transform: "translate(681.89 334.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.18 96.53 286.46 237.48 282.84 237.48 320.56 96.53 324.18 96.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.45,
    y: 94.35,
    width: 2.3,
    height: 145.83,
    transform: "translate(679.2 334.54) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.49 96.53 274.8 229.92 274.8 156.6 290.87 96.53 310.49 96.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.14 109.32 407.14 122.85 376.46 237.48 372.84 237.48 407.14 109.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.14 136.64 407.14 209.96 399.78 237.48 380.16 237.48 407.14 136.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.07,
    cy: 121.98,
    r: 20.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.07,
    cy: 121.98,
    r: 17.24,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.26 133.81 119.26 121.76 111.27 126.28",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.26,134.81a1,1,0,0,1-1-1V123.47l-6.49,3.68a1,1,0,0,1-1.37-.38,1,1,0,0,1,.38-1.36l8-4.52a1,1,0,0,1,1,0,1,1,0,0,1,.5.87v12A1,1,0,0,1,119.26,134.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.72,282H82.58a8.24,8.24,0,0,0,7.88,8.23c12.91.58,32.77,2.63,39.07,9.77,11.74,13.32,10.6,60.09-3.46,70.93-4.41,3.4-17.27,10.14-17.27,10.14h67.7s-12-6.88-16.19-10.14c-14-10.92-14.39-57.68-2.6-70.93,6.06-6.8,24.67-9,37.16-9.69A8.32,8.32,0,0,0,202.72,282Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.46,290.7c12.2,1,26.83,3.39,32.07,9.33a23.59,23.59,0,0,1,4,6.88h20.18a24,24,0,0,1,4-6.88c5.26-5.91,20-8.34,32-9.33Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.54 282.09 149.91 263.41 173.59 263.41 175.23 282.09 151.54 282.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.54 282.09 149.91 263.41 148.63 263.41 150.27 282.09 151.54 282.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.79 280.18 152.49 265.32 171.34 265.32 172.65 280.18 153.79 280.18",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.24 278.96 154.15 266.54 169.9 266.54 170.99 278.96 155.24 278.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.86 282.03 120.07 282.03 122.71 251.86 146.5 251.86 143.86 282.03",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.86 282.03 145 282.03 147.64 251.86 146.5 251.86 143.86 282.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.71 278.95 122.77 278.95 124.87 254.94 143.81 254.94 141.71 278.95",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 276.98 124.5 276.98 126.25 256.91 142.07 256.91 140.32 276.98",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.33,265.94h0a2.76,2.76,0,0,0,3.89,0h0a2.74,2.74,0,0,0,0-3.89h0a2.74,2.74,0,0,0-3.89,0h0A2.74,2.74,0,0,0,132.33,265.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49,269.31h0a2,2,0,0,0-2.85,0h0a2,2,0,0,0,1.43,3.44h0A2,2,0,0,0,133.49,269.31Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-38"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-38",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6,391.54s-5-10.8.7-21.45,7.3-13.17,3.69-15.35-5.26,8.52-5.26,8.52a24,24,0,0,1-.53-15.07c2.51-7.71,4.09-20.26.66-21.6S90.2,342.24,87.23,348a49.82,49.82,0,0,1-2.91-12.64c-.41-6.19.23-16.08-2.48-18.61s-4.44-.78-1.78,12.88a142.9,142.9,0,0,1,2.64,24.76S76.82,336.51,72.88,336s-3.94,5.28-.56,10.31,9.88,14.05,11,18.69c0,0-6.45-13.48-12.25-9.35s5,12.28,9.89,15.22,8.19,21.4,8.19,21.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,391.54s-5-10.8.7-21.45,7.3-13.17,3.69-15.35-5.26,8.52-5.26,8.52a24,24,0,0,1-.53-15.07c2.51-7.71,4.09-20.26.66-21.6S90.2,342.24,87.23,348a49.82,49.82,0,0,1-2.91-12.64c-.41-6.19.23-16.08-2.48-18.61s-4.44-.78-1.78,12.88a142.9,142.9,0,0,1,2.64,24.76S76.82,336.51,72.88,336s-3.94,5.28-.56,10.31,9.88,14.05,11,18.69c0,0-6.45-13.48-12.25-9.35s5,12.28,9.89,15.22,8.19,21.4,8.19,21.4Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.69,396s4.82-10.88-1-21.45-7.45-13-3.87-15.29,5.36,8.44,5.36,8.44a24.07,24.07,0,0,0,.35-15.07c-2.6-7.67-4.33-20.2-.92-21.6s.85,15.65,3.89,21.4a50.13,50.13,0,0,0,2.76-12.68c.34-6.2-.42-16.07,2.25-18.65s4.43-.85,1.94,12.85a143,143,0,0,0-2.35,24.8s5.67-18,9.6-18.58,4,5.22.69,10.3-9.72,14.2-10.73,18.85c0,0,6.29-13.58,12.14-9.53s-4.9,12.35-9.7,15.37-7.94,21.51-7.94,21.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.93 388.22 70.09 388.22 73.31 416.73 106.7 416.73 109.93 388.22",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.3,114V392.5a4.33,4.33,0,0,1-4.4,4.33h-148a3.89,3.89,0,0,1-3.61-2.35,4.11,4.11,0,0,1-.33-1.62V113.67a3.51,3.51,0,0,1,3.37-3.64h39.19a2.76,2.76,0,0,1,2.52,1.76l1.63,4a2.69,2.69,0,0,0,.55.86.57.57,0,0,0,.13.14l.17.15a1.85,1.85,0,0,0,.27.19,2.11,2.11,0,0,0,.59.27,2.42,2.42,0,0,0,.81.14h57.95a2.73,2.73,0,0,0,2.52-1.72l1.63-4a2.76,2.76,0,0,1,2.52-1.77h38.62A4,4,0,0,1,278.3,114Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.99,
    y: 128.81,
    width: 156.3,
    height: 245,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.99,
    y: 343.55,
    width: 156.3,
    height: 30.26,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.99,
    y: 128.81,
    width: 156.3,
    height: 25.1,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,141.36a8.51,8.51,0,0,0,2.52,6.06l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11l.09,0a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18a8.55,8.55,0,1,0-14-6.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.81,139.66s-1.05,4,.29,5.18,8.86,1.19,9.94-.3-1.37-6.38-1.37-6.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.83,147.52a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11v.06l.09-.08a8.45,8.45,0,0,0,3.27-1.55c-.05-.14-.1-.29-.16-.43h-.06l-.07,0c-.19-.06-.59-.19-1.14-.33h-.06c-.32-.08-.69-.17-1.1-.25l-.8-.15h-.12c-.24,0-.49-.08-.75-.11l-.28,0c-.39-.05-.8-.08-1.22-.11h-.43l-.57,0c-.24,0-.47,0-.71,0l-.57.08h0l-1,.17C131.12,147.14,130.4,147.34,129.83,147.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.83,147.52a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11v.06l.09-.08a8.45,8.45,0,0,0,3.27-1.55c-.05-.14-.1-.29-.16-.43h-.06l-.07,0c-.19-.06-.59-.19-1.14-.33h-.06c-.32-.08-.69-.17-1.1-.25l-.8-.15h-.12c-.24,0-.49-.08-.75-.11l-.28,0c-.39-.05-.8-.08-1.22-.11h-.43l-.57,0c-.24,0-.47,0-.71,0l-.57.08h0l-1,.17C131.12,147.14,130.4,147.34,129.83,147.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93,139.39s.45-6.47-5.25-5c-7.16,1.88-3,10.49.5,9.39A7.88,7.88,0,0,0,139.93,139.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,147.06l1.26,2.46.11.21.18,0a6.86,6.86,0,0,0,.91.12l.68-.91c.07.29.13.6.2.93l.49,0c-.05-.56-.09-.91-.09-.91l.61.85c.21,0,.43-.06.64-.11l.12-2.68-.26-.11h0a4.84,4.84,0,0,0-.82-.25l-.18,0a6.73,6.73,0,0,0-1.73,0l-.52.07a5.16,5.16,0,0,0-.84.17h0a7,7,0,0,0-.72.2Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,147.71l-2.8-.79c1.72-1.18.85-3.83.85-3.83l2.77,1a8.67,8.67,0,0,0-.29,1.18c-.29,1.73.49,1.87.49,1.87Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,144.06a8.67,8.67,0,0,0-.29,1.18,7,7,0,0,1-2.48-2.15Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,136c2.5-.16,3.4,1.13,3.75,3.7.43,3.21-.13,5.55-3.31,5.07C132.36,144.14,132.07,136.3,136.24,136Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,139.69a5.41,5.41,0,0,0,.79,1,.68.68,0,0,1-.64.32Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,139.59c0,.2-.08.38-.22.39s-.26-.14-.28-.35.08-.38.22-.39S136.79,139.38,136.81,139.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.47,139.25l.43-.21S136.71,139.44,136.47,139.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,139.32c0,.21-.08.38-.21.39s-.27-.14-.28-.35.07-.38.21-.39S139.34,139.12,139.36,139.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,139l.44-.22S139.27,139.17,139,139Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,138.67a.33.33,0,0,1-.21-.07.36.36,0,0,1-.09-.5,1.7,1.7,0,0,1,1.39-.6.34.34,0,0,1,.33.38.36.36,0,0,1-.38.34.94.94,0,0,0-.74.3A.38.38,0,0,1,135.61,138.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,138.14a.41.41,0,0,1-.18,0,.86.86,0,0,0-.69-.12.36.36,0,0,1-.47-.2.34.34,0,0,1,.18-.46,1.5,1.5,0,0,1,1.34.15.37.37,0,0,1-.18.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.77,140.43a7.51,7.51,0,0,0,.76-3.71s4.83-2.35,5.4,2.67c0,0,.2-4.5-4.12-4.32s-3.88,6.48-1.54,8.21A3.11,3.11,0,0,1,133.77,140.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21,140.94A1.1,1.1,0,0,0,133,140c-.77.13-1,1.75.92,2C134.16,142.06,134.3,141.78,134.21,140.94Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,142a7.06,7.06,0,0,0-.26.88h-.16c-.74-.05-1.06-.31-1.2-.59a.92.92,0,0,1-.08-.44.84.84,0,0,1,0-.26,3.46,3.46,0,0,0,1.41.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.55,142l-.08.26a2.21,2.21,0,0,1-1.37-.4.84.84,0,0,1,0-.26A3.46,3.46,0,0,0,138.55,142Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,142.87c-.74-.05-1.06-.31-1.2-.59a2.26,2.26,0,0,1,.81.21A1,1,0,0,1,138.38,142.87Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,136.22s-.75,4.19-3.35,4.31,1.07-5.37,1.07-5.37,4.14-1.87,6.37.24-.36,4-.36,4S139.89,136.19,136.2,136.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,140.1a.26.26,0,0,1-.22-.13.25.25,0,0,1,.1-.34c1.81-1,1.38-3.63,1.38-3.65a.24.24,0,0,1,.2-.29.24.24,0,0,1,.29.2c0,.12.49,3-1.63,4.18A.27.27,0,0,1,134.65,140.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,140.12a.06.06,0,0,0,.06.06h0l.23,0h.35l1.84-.17a1.17,1.17,0,0,0,2.3,0,1.21,1.21,0,0,0,0-.19c.09-.12.17-.19.25-.19a.28.28,0,0,1,.17.1,1.19,1.19,0,0,0,.71.87l.26.07a1,1,0,0,0,.48,0,1.1,1.1,0,0,0,.5-.29,1.06,1.06,0,0,0,.34-.66,1.15,1.15,0,0,0-1-1.33h-.27a1.16,1.16,0,0,0-1.06,1,1.09,1.09,0,0,0,0,.18.33.33,0,0,0-.14,0,.4.4,0,0,0-.28.14,1.17,1.17,0,0,0-1-1h-.12a1,1,0,0,0-.48.07h0a1.17,1.17,0,0,0-.72.9,1,1,0,0,0,0,.25l-1.59.13-.33,0-.49,0h0S133.39,140.08,133.4,140.12Zm5.36-.83a1,1,0,0,1,1-.86h.2a1,1,0,0,1,.85,1.16,1.05,1.05,0,0,1-.71.82,1.14,1.14,0,0,1-.45,0l-.2,0A1,1,0,0,1,138.76,139.29Zm-2.72.31a1,1,0,1,1,2,.31,1,1,0,1,1-2-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.4,140.12a.06.06,0,0,0,.06.06h0l.23,0h.35l1.84-.17a1.17,1.17,0,0,0,2.3,0,1.21,1.21,0,0,0,0-.19c.09-.12.17-.19.25-.19a.28.28,0,0,1,.17.1,1.19,1.19,0,0,0,.71.87l.26.07a1,1,0,0,0,.48,0,1.1,1.1,0,0,0,.5-.29,1.06,1.06,0,0,0,.34-.66,1.15,1.15,0,0,0-1-1.33h-.27a1.16,1.16,0,0,0-1.06,1,1.09,1.09,0,0,0,0,.18.33.33,0,0,0-.14,0,.4.4,0,0,0-.28.14,1.17,1.17,0,0,0-1-1h-.12a1,1,0,0,0-.48.07h0a1.17,1.17,0,0,0-.72.9,1,1,0,0,0,0,.25l-1.59.13-.33,0-.49,0h0S133.39,140.08,133.4,140.12Zm5.36-.83a1,1,0,0,1,1-.86h.2a1,1,0,0,1,.85,1.16,1.05,1.05,0,0,1-.71.82,1.14,1.14,0,0,1-.45,0l-.2,0A1,1,0,0,1,138.76,139.29Zm-2.72.31a1,1,0,1,1,2,.31,1,1,0,1,1-2-.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134 145.91 135.75 147.63 135.05 149.74 132.62 147.06 134 145.91",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.53 146.27 136.25 147.59 137.16 149.46 137.72 147.03 136.53 146.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,149.69a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18-.43-.21a11,11,0,0,0-2.44-.7.42.42,0,0,0,0,.07A3.23,3.23,0,0,1,137.69,149.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.72,147.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S130.76,147.07,129.72,147.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.72,147.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S130.76,147.07,129.72,147.42Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134 145.91 135.75 147.63 135.05 149.74 132.62 147.06 134 145.91",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.53 146.27 136.25 147.59 137.16 149.46 137.72 147.03 136.53 146.27",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.69,149.69a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18-.43-.21a11,11,0,0,0-2.44-.7.42.42,0,0,0,0,.07A3.23,3.23,0,0,1,137.69,149.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.72,147.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S130.76,147.07,129.72,147.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.71,143.27h-29.8a1.91,1.91,0,0,1-1.91-1.91h0a1.9,1.9,0,0,1,1.91-1.91h29.8a1.9,1.9,0,0,1,1.91,1.91h0A1.91,1.91,0,0,1,179.71,143.27Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 229.18,
    y: 138.81,
    width: 6.79,
    height: 5.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "237.89 143.27 236.24 142.52 236.24 140.19 237.89 139.44 237.89 143.27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.12,137.23l-1,.67,1.92,1.92.55-.47a.93.93,0,0,1,1.24.05l1.78,1.78a.93.93,0,0,1,0,1.24l-.47.55,1.92,1.92.67-1a2.14,2.14,0,0,0-.25-2.73l-3.72-3.72A2.14,2.14,0,0,0,248.12,137.23Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 246.05,
    y: 138.84,
    width: 3.21,
    height: 0.96,
    transform: "translate(171.05 -134.31) rotate(45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 251.12,
    y: 143.91,
    width: 3.21,
    height: 0.96,
    transform: "translate(176.11 -136.41) rotate(45)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.71,138h-6.47a.39.39,0,0,0,0,.77h6.47a.39.39,0,1,0,0-.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.71,140h-6.47a.39.39,0,0,0-.38.39.38.38,0,0,0,.38.38h6.47a.38.38,0,0,0,.39-.38A.39.39,0,0,0,272.71,140Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.71,142h-6.47a.38.38,0,1,0,0,.76h6.47a.38.38,0,1,0,0-.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.71,144h-6.47a.38.38,0,1,0,0,.76h6.47a.38.38,0,1,0,0-.76Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 140.19,
    y: 119.26,
    width: 2.04,
    height: 2.72,
    transform: "translate(282.41 241.23) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.86,
    y: 118.35,
    width: 2.04,
    height: 3.62,
    transform: "translate(275.77 240.32) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.54,
    y: 117.44,
    width: 2.04,
    height: 4.53,
    transform: "translate(269.12 239.42) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.22,
    y: 116.54,
    width: 2.04,
    height: 5.44,
    transform: "translate(262.47 238.51) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.41,
    y: 118.26,
    width: 1.21,
    height: 2.72,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.45,
    y: 117.27,
    width: 9.63,
    height: 4.7,
    transform: "translate(530.53 239.25) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.92,
    y: 350.76,
    width: 120.63,
    height: 15.82,
    rx: 7.91,
    transform: "translate(422.47 717.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.42,187l-45.82.33-4.83,3v-23a5.53,5.53,0,0,1,5.54-5.53l45.11-.34A5.54,5.54,0,0,1,208,167v14.47A5.54,5.54,0,0,1,202.42,187Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,169.64H158.86a.5.5,0,0,1,0-1H200a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,174.72H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H200a.5.5,0,0,1,.5.5A.5.5,0,0,1,200,174.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,179.79H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H184a.5.5,0,0,1,.5.5A.5.5,0,0,1,184,179.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.89,
    cy: 358.68,
    r: 7.82,
    transform: "translate(-213.53 201.85) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.81,117.53,145.7,275.3h0l-.47,1.77h0l-.76,2.84h0l-.48,1.77-22,82.38v-99.7L163.21,110h1.34a2.76,2.76,0,0,1,2.52,1.76l1.62,4a2.75,2.75,0,0,0,2.52,1.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.24,117.53h0L160.38,274.31l-.25.94-2.29,8.59-.25.94L127.68,396.83h-1.75a3.89,3.89,0,0,1-3.61-2.35l29.28-109.7.26-.94,2.29-8.59.25-.94,41.86-156.77h6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.2,170.36a8.51,8.51,0,0,0,2.52,6.06l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11l.09,0a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18a8.55,8.55,0,1,0-14-6.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,168.66s-1.05,4,.29,5.18,8.86,1.19,9.94-.3-1.37-6.38-1.37-6.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,176.52a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11v.06l.09-.08a8.45,8.45,0,0,0,3.27-1.55c-.05-.14-.1-.29-.16-.43h-.06l-.07,0c-.19-.06-.59-.19-1.14-.33h-.06c-.32-.08-.69-.17-1.1-.25l-.8-.15h-.12c-.24,0-.49-.08-.75-.11l-.28,0c-.39-.05-.8-.08-1.22-.11h-.43l-.57,0c-.24,0-.47,0-.71,0l-.57.08h0l-1,.17C134.12,176.14,133.4,176.34,132.83,176.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,176.52a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11v.06l.09-.08a8.45,8.45,0,0,0,3.27-1.55c-.05-.14-.1-.29-.16-.43h-.06l-.07,0c-.19-.06-.59-.19-1.14-.33h-.06c-.32-.08-.69-.17-1.1-.25l-.8-.15h-.12c-.24,0-.49-.08-.75-.11l-.28,0c-.39-.05-.8-.08-1.22-.11h-.43l-.57,0c-.24,0-.47,0-.71,0l-.57.08h0l-1,.17C134.12,176.14,133.4,176.34,132.83,176.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.93,168.39s.45-6.47-5.25-5c-7.16,1.88-3,10.49.5,9.39A7.88,7.88,0,0,0,142.93,168.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,176.06l1.26,2.46.11.21.18,0a6.86,6.86,0,0,0,.91.12l.68-.91c.07.29.13.6.2.93l.49,0c-.05-.56-.09-.91-.09-.91l.61.85c.21,0,.43-.06.64-.11l.12-2.68-.26-.11h0a4.84,4.84,0,0,0-.82-.25l-.18,0a6.73,6.73,0,0,0-1.73,0l-.52.07a5.16,5.16,0,0,0-.84.17h0a7,7,0,0,0-.72.2Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.05,176.71l-2.8-.79c1.72-1.18.85-3.83.85-3.83l2.77,1a8.67,8.67,0,0,0-.29,1.18c-.29,1.73.49,1.87.49,1.87Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,173.06a8.67,8.67,0,0,0-.29,1.18,7,7,0,0,1-2.48-2.15Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24,165c2.5-.16,3.4,1.13,3.75,3.7.43,3.21-.13,5.55-3.31,5.07C135.36,173.14,135.07,165.3,139.24,165Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,168.69a5.41,5.41,0,0,0,.79,1,.68.68,0,0,1-.64.32Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,168.59c0,.2-.08.38-.22.39s-.26-.14-.28-.35.08-.38.22-.39S139.79,168.38,139.81,168.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47,168.25l.43-.21S139.71,168.44,139.47,168.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.36,168.32c0,.21-.08.38-.21.39s-.27-.14-.28-.35.07-.38.21-.39S142.34,168.12,142.36,168.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,168l.44-.22S142.27,168.17,142,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61,167.67a.33.33,0,0,1-.21-.07.36.36,0,0,1-.09-.5,1.7,1.7,0,0,1,1.39-.6.34.34,0,0,1,.33.38.36.36,0,0,1-.38.34.94.94,0,0,0-.74.3A.38.38,0,0,1,138.61,167.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,167.14a.41.41,0,0,1-.18,0,.86.86,0,0,0-.69-.12.36.36,0,0,1-.47-.2.34.34,0,0,1,.18-.46,1.5,1.5,0,0,1,1.34.15.37.37,0,0,1-.18.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77,169.43a7.51,7.51,0,0,0,.76-3.71s4.83-2.35,5.4,2.67c0,0,.2-4.5-4.12-4.32s-3.88,6.48-1.54,8.21A3.11,3.11,0,0,1,136.77,169.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,169.94A1.1,1.1,0,0,0,136,169c-.77.13-1,1.75.92,2C137.16,171.06,137.3,170.78,137.21,169.94Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,171a7.06,7.06,0,0,0-.26.88h-.16c-.74-.05-1.06-.31-1.2-.59a.92.92,0,0,1-.08-.44.84.84,0,0,1,0-.26,3.46,3.46,0,0,0,1.41.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.55,171l-.08.26a2.21,2.21,0,0,1-1.37-.4.84.84,0,0,1,0-.26A3.46,3.46,0,0,0,141.55,171Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38,171.87c-.74-.05-1.06-.31-1.2-.59a2.26,2.26,0,0,1,.81.21A1,1,0,0,1,141.38,171.87Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,165.22s-.75,4.19-3.35,4.31,1.07-5.37,1.07-5.37,4.14-1.87,6.37.24-.36,4-.36,4S142.89,165.19,139.2,165.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,169.1a.26.26,0,0,1-.22-.13.25.25,0,0,1,.1-.34c1.81-1,1.38-3.63,1.38-3.65a.24.24,0,0,1,.2-.29.24.24,0,0,1,.29.2c0,.12.49,3-1.63,4.18A.27.27,0,0,1,137.65,169.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,169.12a.06.06,0,0,0,.06.06h0l.23,0h.35l1.84-.17a1.17,1.17,0,0,0,2.3,0,1.21,1.21,0,0,0,0-.19c.09-.12.17-.19.25-.19a.28.28,0,0,1,.17.1,1.19,1.19,0,0,0,.71.87l.26.07a1,1,0,0,0,.48,0,1.1,1.1,0,0,0,.5-.29,1.06,1.06,0,0,0,.34-.66,1.15,1.15,0,0,0-1-1.33h-.27a1.16,1.16,0,0,0-1.06,1,1.09,1.09,0,0,0,0,.18.33.33,0,0,0-.14,0,.4.4,0,0,0-.28.14,1.17,1.17,0,0,0-1-1h-.12a1,1,0,0,0-.48.07h0a1.17,1.17,0,0,0-.72.9,1,1,0,0,0,0,.25l-1.59.13-.33,0-.49,0h0S136.39,169.08,136.4,169.12Zm5.36-.83a1,1,0,0,1,1-.86h.2a1,1,0,0,1,.85,1.16,1.05,1.05,0,0,1-.71.82,1.14,1.14,0,0,1-.45,0l-.2,0A1,1,0,0,1,141.76,168.29Zm-2.72.31a1,1,0,0,1,2,.31,1,1,0,1,1-2-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.4,169.12a.06.06,0,0,0,.06.06h0l.23,0h.35l1.84-.17a1.17,1.17,0,0,0,2.3,0,1.21,1.21,0,0,0,0-.19c.09-.12.17-.19.25-.19a.28.28,0,0,1,.17.1,1.19,1.19,0,0,0,.71.87l.26.07a1,1,0,0,0,.48,0,1.1,1.1,0,0,0,.5-.29,1.06,1.06,0,0,0,.34-.66,1.15,1.15,0,0,0-1-1.33h-.27a1.16,1.16,0,0,0-1.06,1,1.09,1.09,0,0,0,0,.18.33.33,0,0,0-.14,0,.4.4,0,0,0-.28.14,1.17,1.17,0,0,0-1-1h-.12a1,1,0,0,0-.48.07h0a1.17,1.17,0,0,0-.72.9,1,1,0,0,0,0,.25l-1.59.13-.33,0-.49,0h0S136.39,169.08,136.4,169.12Zm5.36-.83a1,1,0,0,1,1-.86h.2a1,1,0,0,1,.85,1.16,1.05,1.05,0,0,1-.71.82,1.14,1.14,0,0,1-.45,0l-.2,0A1,1,0,0,1,141.76,168.29Zm-2.72.31a1,1,0,0,1,2,.31,1,1,0,1,1-2-.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "137 174.91 138.75 176.63 138.05 178.74 135.62 176.06 137 174.91",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.53 175.27 139.25 176.59 140.16 178.46 140.72 176.03 139.53 175.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,178.69a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18-.43-.21a11,11,0,0,0-2.44-.7.42.42,0,0,0,0,.07A3.23,3.23,0,0,1,140.69,178.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,176.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S133.76,176.07,132.72,176.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,176.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S133.76,176.07,132.72,176.42Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137 174.91 138.75 176.63 138.05 178.74 135.62 176.06 137 174.91",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.53 175.27 139.25 176.59 140.16 178.46 140.72 176.03 139.53 175.27",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.69,178.69a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18-.43-.21a11,11,0,0,0-2.44-.7.42.42,0,0,0,0,.07A3.23,3.23,0,0,1,140.69,178.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,176.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S133.76,176.07,132.72,176.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,203.36a8.5,8.5,0,0,1-3.07,6.56l-.21.18-.06,0-.08.06a8.35,8.35,0,0,1-3.19,1.49l-.09,0c-.21,0-.43.08-.64.11a4.6,4.6,0,0,1-.52.06l-.49,0h-.2c-.23,0-.46,0-.68,0a6.86,6.86,0,0,1-.91-.12l-.18,0A8.39,8.39,0,0,1,257.4,210a5.37,5.37,0,0,1-.57-.5l-.11-.1a8.55,8.55,0,1,1,14.58-6.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 207.17,
    width: 4.77,
    height: 2.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 207.17,
    width: 4.77,
    height: 2.64,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 208.09,
    width: 4.77,
    height: 0.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 208.66,
    width: 4.77,
    height: 0.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 209.23,
    width: 4.77,
    height: 0.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.07,207.17v.67a14.49,14.49,0,0,1-4.76,1v-1.67Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,199.66h-8.34a1.83,1.83,0,0,0-1.83,1.83v4.67a1.83,1.83,0,0,0,1.83,1.82h8.34a1.83,1.83,0,0,0,1.82-1.82v-4.67A1.83,1.83,0,0,0,267.05,199.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,199.66h-3.28a1.83,1.83,0,0,1,1.82,1.83v4.67a1.82,1.82,0,0,1-1.82,1.82h3.28a1.82,1.82,0,0,0,1.82-1.82v-4.67A1.83,1.83,0,0,0,267.05,199.66Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.59,
    y: 200.47,
    width: 7.19,
    height: 6.71,
    rx: 1.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,202.91a.12.12,0,0,1-.13-.12v-5.44a.13.13,0,0,1,.13-.12.13.13,0,0,1,.12.12v5.44A.12.12,0,0,1,267.81,202.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,203.82a2.05,2.05,0,0,1-.17.83,1.56,1.56,0,0,1-.33.5,1.33,1.33,0,0,1-1,.45,1.81,1.81,0,0,1,0-3.56,1.35,1.35,0,0,1,1,.46,1.71,1.71,0,0,1,.32.5A2,2,0,0,1,269.29,203.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.32,205.1a1.3,1.3,0,0,1,0-2.55,1,1,0,0,1,.8.45,1.71,1.71,0,0,0-.32-.5,1,1,0,0,0-.48-.12,1.46,1.46,0,0,0,0,2.88,1,1,0,0,0,.47-.11,1.56,1.56,0,0,0,.33-.5A1,1,0,0,1,268.32,205.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,202.79c0,.29-.13.52-.29.52s-.29-.23-.29-.52.13-.52.29-.52S262.88,202.5,262.88,202.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.48,
    cy: 202.79,
    rx: 0.29,
    ry: 0.52,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,205.21a8.73,8.73,0,0,1,.79,1l.2-.1c.9-.44,1.17-.94,1.2-1.37a1.37,1.37,0,0,0-.12-.6,1.41,1.41,0,0,0-.18-.3,4.68,4.68,0,0,1-1.59,1.23A2.45,2.45,0,0,1,261,205.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,205.05l.24.29c.85-.42,1.39-.83,1.53-1.22a1.41,1.41,0,0,0-.18-.3A4.68,4.68,0,0,1,261.32,205.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,206.09c.9-.44,1.17-.94,1.2-1.37a3.42,3.42,0,0,0-.91.69A1.25,1.25,0,0,0,262,206.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.88,210.2a8.35,8.35,0,0,1-3.19,1.49l-.09,0c-.21,0-.43.08-.64.11a4.6,4.6,0,0,1-.52.06l-.49,0h-.2c-.23,0-.46,0-.68,0a6.86,6.86,0,0,1-.91-.12l-.18,0A8.39,8.39,0,0,1,257.4,210a2.31,2.31,0,0,1,1.41-.48h7.47A2.28,2.28,0,0,1,267.88,210.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.31,225.66h66l4.82,3V200.34a5.52,5.52,0,0,0-5.53-5.53H176.31a5.53,5.53,0,0,0-5.54,5.53v19.79A5.54,5.54,0,0,0,176.31,225.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,202.64H178.86a.5.5,0,0,1,0-1H240a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,207.72H178.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5A.5.5,0,0,1,240,207.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,212.79H178.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5A.5.5,0,0,1,240,212.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,217.87H178.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H210a.5.5,0,0,1,.5.5A.5.5,0,0,1,210,217.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.58,273.66h-75l-4.83,3V243.34a5.53,5.53,0,0,1,5.54-5.53h74.27a5.52,5.52,0,0,1,5.53,5.53v24.79A5.53,5.53,0,0,1,231.58,273.66Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,245.64H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H230a.5.5,0,0,1,.5.5A.5.5,0,0,1,230,245.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,250.72H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H230a.5.5,0,0,1,.5.5A.5.5,0,0,1,230,250.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,255.79H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H230a.5.5,0,0,1,.5.5A.5.5,0,0,1,230,255.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,266H158.86a.5.5,0,0,1,0-1H190a.5.5,0,1,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,260.87H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H230a.5.5,0,0,1,.5.5A.5.5,0,0,1,230,260.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.2,246.36a8.51,8.51,0,0,0,2.52,6.06l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11l.09,0a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18a8.55,8.55,0,1,0-14-6.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,244.66s-1.05,4,.29,5.18,8.86,1.19,9.94-.3-1.37-6.38-1.37-6.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,252.52a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11v.06l.09-.08a8.45,8.45,0,0,0,3.27-1.55c-.05-.14-.1-.29-.16-.43h-.06l-.07,0c-.19-.06-.59-.19-1.14-.33h-.06c-.32-.08-.69-.17-1.1-.25l-.8-.15h-.12c-.24,0-.49-.08-.75-.11l-.28,0c-.39-.05-.8-.08-1.22-.11h-.43l-.57,0c-.24,0-.47,0-.71,0l-.57.08h0l-1,.17C134.12,252.14,133.4,252.34,132.83,252.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,252.52a8.47,8.47,0,0,0,4.15,2.21l.18,0a6.86,6.86,0,0,0,.91.12c.22,0,.45,0,.68,0h.2l.49,0a4.6,4.6,0,0,0,.52-.06c.21,0,.43-.06.64-.11v.06l.09-.08a8.45,8.45,0,0,0,3.27-1.55c-.05-.14-.1-.29-.16-.43h-.06l-.07,0c-.19-.06-.59-.19-1.14-.33h-.06c-.32-.08-.69-.17-1.1-.25l-.8-.15h-.12c-.24,0-.49-.08-.75-.11l-.28,0c-.39-.05-.8-.08-1.22-.11h-.43l-.57,0c-.24,0-.47,0-.71,0l-.57.08h0l-1,.17C134.12,252.14,133.4,252.34,132.83,252.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.93,244.39s.45-6.47-5.25-5c-7.16,1.88-3,10.49.5,9.39A7.88,7.88,0,0,0,142.93,244.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,252.06l1.26,2.46.11.21.18,0a6.86,6.86,0,0,0,.91.12l.68-.91c.07.29.13.6.2.93l.49,0c-.05-.56-.09-.91-.09-.91l.61.85c.21,0,.43-.06.64-.11l.12-2.68-.26-.11h0a4.84,4.84,0,0,0-.82-.25l-.18,0a6.73,6.73,0,0,0-1.73,0l-.52.07a5.16,5.16,0,0,0-.84.17h0a7,7,0,0,0-.72.2Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.05,252.71l-2.8-.79c1.72-1.18.85-3.83.85-3.83l2.77,1a8.67,8.67,0,0,0-.29,1.18c-.29,1.73.49,1.87.49,1.87Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,249.06a8.67,8.67,0,0,0-.29,1.18,7,7,0,0,1-2.48-2.15Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24,241c2.5-.16,3.4,1.13,3.75,3.7.43,3.21-.13,5.55-3.31,5.07C135.36,249.14,135.07,241.3,139.24,241Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,244.69a5.41,5.41,0,0,0,.79,1,.68.68,0,0,1-.64.32Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,244.59c0,.2-.08.38-.22.39s-.26-.14-.28-.35.08-.38.22-.39S139.79,244.38,139.81,244.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47,244.25l.43-.21S139.71,244.43,139.47,244.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.36,244.32c0,.21-.08.38-.21.39s-.27-.14-.28-.35.07-.38.21-.39S142.34,244.12,142.36,244.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,244l.44-.22S142.27,244.17,142,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61,243.67a.33.33,0,0,1-.21-.07.36.36,0,0,1-.09-.5,1.67,1.67,0,0,1,1.39-.6.36.36,0,0,1,0,.72.94.94,0,0,0-.74.3A.38.38,0,0,1,138.61,243.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,243.14a.41.41,0,0,1-.18,0,.86.86,0,0,0-.69-.12.37.37,0,0,1-.47-.2.36.36,0,0,1,.18-.47,1.56,1.56,0,0,1,1.34.16.37.37,0,0,1,.13.5A.37.37,0,0,1,142.5,243.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77,245.43a7.51,7.51,0,0,0,.76-3.71s4.83-2.35,5.4,2.67c0,0,.2-4.5-4.12-4.32s-3.88,6.48-1.54,8.21A3.11,3.11,0,0,1,136.77,245.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,245.94A1.1,1.1,0,0,0,136,245c-.77.13-1,1.75.92,2C137.16,247.06,137.3,246.78,137.21,245.94Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,247a7.06,7.06,0,0,0-.26.88h-.16c-.74-.05-1.06-.31-1.2-.59a.92.92,0,0,1-.08-.44.84.84,0,0,1,0-.26,3.46,3.46,0,0,0,1.41.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.55,247l-.08.26a2.21,2.21,0,0,1-1.37-.4.84.84,0,0,1,0-.26A3.46,3.46,0,0,0,141.55,247Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38,247.87c-.74-.05-1.06-.31-1.2-.59a2.26,2.26,0,0,1,.81.21A1,1,0,0,1,141.38,247.87Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,241.22s-.75,4.19-3.35,4.31,1.07-5.37,1.07-5.37,4.14-1.87,6.37.24-.36,4-.36,4S142.89,241.19,139.2,241.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,245.1a.26.26,0,0,1-.22-.13.25.25,0,0,1,.1-.34c1.81-1,1.38-3.63,1.38-3.65a.24.24,0,0,1,.2-.29.25.25,0,0,1,.29.2c0,.12.49,3-1.63,4.18A.27.27,0,0,1,137.65,245.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4,245.12a.06.06,0,0,0,.06.06h0l.23,0h.35l1.84-.17a1.19,1.19,0,0,0,1,.95,1.18,1.18,0,0,0,1.33-1,1.21,1.21,0,0,0,0-.19c.09-.12.17-.19.25-.19a.28.28,0,0,1,.17.1,1.19,1.19,0,0,0,.71.87l.26.07a1,1,0,0,0,.48,0,1.1,1.1,0,0,0,.5-.29,1.06,1.06,0,0,0,.34-.66,1.15,1.15,0,0,0-1-1.33h-.27a1.16,1.16,0,0,0-1.06,1,1.09,1.09,0,0,0,0,.18.33.33,0,0,0-.14,0,.4.4,0,0,0-.28.14,1.17,1.17,0,0,0-1-1h-.12a1,1,0,0,0-.48.07h0a1.17,1.17,0,0,0-.72.9,1,1,0,0,0,0,.25l-1.59.13-.33,0-.49,0h0S136.39,245.08,136.4,245.12Zm5.36-.83a1,1,0,0,1,1-.86h.2a1,1,0,0,1,.85,1.16,1.05,1.05,0,0,1-.71.82,1.14,1.14,0,0,1-.45,0l-.2,0A1,1,0,0,1,141.76,244.29Zm-2.72.31a1,1,0,0,1,2,.31,1,1,0,1,1-2-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.4,245.12a.06.06,0,0,0,.06.06h0l.23,0h.35l1.84-.17a1.19,1.19,0,0,0,1,.95,1.18,1.18,0,0,0,1.33-1,1.21,1.21,0,0,0,0-.19c.09-.12.17-.19.25-.19a.28.28,0,0,1,.17.1,1.19,1.19,0,0,0,.71.87l.26.07a1,1,0,0,0,.48,0,1.1,1.1,0,0,0,.5-.29,1.06,1.06,0,0,0,.34-.66,1.15,1.15,0,0,0-1-1.33h-.27a1.16,1.16,0,0,0-1.06,1,1.09,1.09,0,0,0,0,.18.33.33,0,0,0-.14,0,.4.4,0,0,0-.28.14,1.17,1.17,0,0,0-1-1h-.12a1,1,0,0,0-.48.07h0a1.17,1.17,0,0,0-.72.9,1,1,0,0,0,0,.25l-1.59.13-.33,0-.49,0h0S136.39,245.08,136.4,245.12Zm5.36-.83a1,1,0,0,1,1-.86h.2a1,1,0,0,1,.85,1.16,1.05,1.05,0,0,1-.71.82,1.14,1.14,0,0,1-.45,0l-.2,0A1,1,0,0,1,141.76,244.29Zm-2.72.31a1,1,0,0,1,2,.31,1,1,0,1,1-2-.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "137 250.91 138.75 252.63 138.05 254.74 135.62 252.06 137 250.91",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.53 251.27 139.25 252.59 140.16 254.46 140.72 252.03 139.53 251.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,254.69a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18-.43-.21a11,11,0,0,0-2.44-.7.42.42,0,0,0,0,.07A3.23,3.23,0,0,1,140.69,254.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,252.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S133.76,252.07,132.72,252.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,252.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S133.76,252.07,132.72,252.42Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137 250.91 138.75 252.63 138.05 254.74 135.62 252.06 137 250.91",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.53 251.27 139.25 252.59 140.16 254.46 140.72 252.03 139.53 251.27",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.69,254.69a8.45,8.45,0,0,0,3.27-1.55l.06,0,.21-.18-.43-.21a11,11,0,0,0-2.44-.7.42.42,0,0,0,0,.07A3.23,3.23,0,0,1,140.69,254.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,252.42l.11.1a8.47,8.47,0,0,0,4.15,2.21l.18,0a2.17,2.17,0,0,1-.29-.24c-.13-.11-.26-.24-.39-.37s-.31-.33-.45-.5-.09-.12-.14-.17l-.25-.33-.23-.33c-.07-.1-.14-.2-.19-.29s-.27-.42-.34-.55a1.21,1.21,0,0,1-.08-.15S133.76,252.07,132.72,252.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,293.36a8.5,8.5,0,0,1-3.07,6.56l-.21.18-.06,0-.08.06a8.35,8.35,0,0,1-3.19,1.49l-.09,0c-.21.05-.43.08-.64.11a4.6,4.6,0,0,1-.52.06l-.49,0h-.2c-.23,0-.46,0-.68,0a6.86,6.86,0,0,1-.91-.12l-.18,0A8.39,8.39,0,0,1,257.4,300a5.37,5.37,0,0,1-.57-.5l-.11-.1a8.55,8.55,0,1,1,14.58-6.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 297.17,
    width: 4.77,
    height: 2.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 297.17,
    width: 4.77,
    height: 2.64,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 298.09,
    width: 4.77,
    height: 0.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 298.66,
    width: 4.77,
    height: 0.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.31,
    y: 299.23,
    width: 4.77,
    height: 0.13,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.07,297.17v.67a14.49,14.49,0,0,1-4.76,1v-1.67Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,289.66h-8.34a1.83,1.83,0,0,0-1.83,1.83v4.67a1.83,1.83,0,0,0,1.83,1.82h8.34a1.83,1.83,0,0,0,1.82-1.82v-4.67A1.83,1.83,0,0,0,267.05,289.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,289.66h-3.28a1.83,1.83,0,0,1,1.82,1.83v4.67a1.82,1.82,0,0,1-1.82,1.82h3.28a1.82,1.82,0,0,0,1.82-1.82v-4.67A1.83,1.83,0,0,0,267.05,289.66Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.59,
    y: 290.47,
    width: 7.19,
    height: 6.71,
    rx: 1.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,292.91a.12.12,0,0,1-.13-.12v-5.44a.13.13,0,0,1,.13-.12.13.13,0,0,1,.12.12v5.44A.12.12,0,0,1,267.81,292.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,293.82a2.05,2.05,0,0,1-.17.83,1.56,1.56,0,0,1-.33.5,1.33,1.33,0,0,1-1,.45,1.81,1.81,0,0,1,0-3.56,1.35,1.35,0,0,1,1,.46,1.71,1.71,0,0,1,.32.5A2,2,0,0,1,269.29,293.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.32,295.1a1.3,1.3,0,0,1,0-2.55,1,1,0,0,1,.8.45,1.71,1.71,0,0,0-.32-.5,1,1,0,0,0-.48-.12,1.46,1.46,0,0,0,0,2.88,1,1,0,0,0,.47-.11,1.56,1.56,0,0,0,.33-.5A1,1,0,0,1,268.32,295.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,292.79c0,.29-.13.52-.29.52s-.29-.23-.29-.52.13-.52.29-.52S262.88,292.5,262.88,292.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.48,
    cy: 292.79,
    rx: 0.29,
    ry: 0.52,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,295.21a8.73,8.73,0,0,1,.79,1l.2-.1c.9-.44,1.17-.94,1.2-1.37a1.37,1.37,0,0,0-.12-.6,1.41,1.41,0,0,0-.18-.3,4.68,4.68,0,0,1-1.59,1.23A2.45,2.45,0,0,1,261,295.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,295.05l.24.29c.85-.42,1.39-.83,1.53-1.22a1.41,1.41,0,0,0-.18-.3A4.68,4.68,0,0,1,261.32,295.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,296.09c.9-.44,1.17-.94,1.2-1.37a3.42,3.42,0,0,0-.91.69A1.25,1.25,0,0,0,262,296.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.88,300.2a8.35,8.35,0,0,1-3.19,1.49l-.09,0c-.21.05-.43.08-.64.11a4.6,4.6,0,0,1-.52.06l-.49,0h-.2c-.23,0-.46,0-.68,0a6.86,6.86,0,0,1-.91-.12l-.18,0A8.39,8.39,0,0,1,257.4,300a2.31,2.31,0,0,1,1.41-.48h7.47A2.28,2.28,0,0,1,267.88,300.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.31,325.66h85l4.82,3V290.34a5.52,5.52,0,0,0-5.53-5.53H157.31a5.53,5.53,0,0,0-5.54,5.53v29.79A5.54,5.54,0,0,0,157.31,325.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,292.64H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5A.5.5,0,0,1,240,292.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,297.72H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5A.5.5,0,0,1,240,297.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,302.79H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5A.5.5,0,0,1,240,302.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,313H158.86a.5.5,0,0,1,0-1H240a.5.5,0,1,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,318H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H191a.5.5,0,0,1,.5.5A.5.5,0,0,1,191,318Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,307.87H158.86a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H240a.5.5,0,0,1,.5.5A.5.5,0,0,1,240,307.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.49,177.5h-78a5.92,5.92,0,0,0-5.92,5.92V206.3a5.92,5.92,0,0,0,5.92,5.92h35.36l5.42,11.16V212.22h37.18a5.92,5.92,0,0,0,5.93-5.92V183.42A5.92,5.92,0,0,0,384.49,177.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.36,190v8.39h-1.2v-3.74h-4.82v3.74h-1.2V190h1.2v3.61h4.82V190Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.43,195.59h-5.15a2.15,2.15,0,0,0,2.3,1.86,2.34,2.34,0,0,0,1.83-.77l.64.74a3.47,3.47,0,0,1-5.93-2.22,3.11,3.11,0,0,1,3.19-3.23,3.07,3.07,0,0,1,3.15,3.27A2.16,2.16,0,0,1,328.43,195.59Zm-5.15-.83h4.07a2,2,0,0,0-4.07,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.06,189.48h1.15v8.9h-1.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,189.48h1.16v8.9H333.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.16,195.2a3.31,3.31,0,1,1,3.31,3.25A3.16,3.16,0,0,1,336.16,195.2Zm5.45,0a2.14,2.14,0,1,0-2.14,2.25A2.09,2.09,0,0,0,341.61,195.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.17,198a2.14,2.14,0,0,1-1.39.44,1.81,1.81,0,0,1-2-2V193h-1.08V192h1.08v-1.39h1.15V192h1.82V193h-1.82v3.45a.93.93,0,0,0,1,1.06,1.4,1.4,0,0,0,.9-.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,194.72v3.66h-1.15v-3.52c0-1.25-.62-1.86-1.72-1.86a1.88,1.88,0,0,0-2,2.11v3.27h-1.15v-8.9h1.15v3.45a2.73,2.73,0,0,1,2.24-1A2.46,2.46,0,0,1,358.6,194.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,195.59h-5.16a2.15,2.15,0,0,0,2.3,1.86,2.37,2.37,0,0,0,1.84-.77l.63.74a3.15,3.15,0,0,1-2.5,1,3.18,3.18,0,0,1-3.42-3.25,3.1,3.1,0,0,1,3.19-3.23,3.07,3.07,0,0,1,3.14,3.27C366.52,195.34,366.51,195.48,366.5,195.59Zm-5.16-.83h4.08a2.05,2.05,0,0,0-4.08,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.54,192v1.11h-.27a1.9,1.9,0,0,0-2,2.15v3.16h-1.15V192h1.1v1.06A2.44,2.44,0,0,1,371.54,192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.62,195.59h-5.16a2.15,2.15,0,0,0,2.3,1.86,2.37,2.37,0,0,0,1.84-.77l.63.74a3.15,3.15,0,0,1-2.5,1,3.18,3.18,0,0,1-3.42-3.25A3.1,3.1,0,0,1,375.5,192a3.07,3.07,0,0,1,3.14,3.27C378.64,195.34,378.63,195.48,378.62,195.59Zm-5.16-.83h4.08a2.05,2.05,0,0,0-4.08,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.47,296.36H344s-11.2,19.09-20.92,18c-7.69-.9-11.84-14.92-11.84-14.92l-5.28.3s2.73,18.18,15.51,21.36C338.71,325.36,352.47,296.36,352.47,296.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.47,296.36a70.79,70.79,0,0,1-4.3,7.49l-.46.71c-.91,1.37-1.95,2.82-3.08,4.27l-.53.67a51.2,51.2,0,0,1-3.63,4.08l-.61.6a35.91,35.91,0,0,1-4.28,3.56l-.71.48a23,23,0,0,1-3.89,2l-.8.29a15.06,15.06,0,0,1-5.77.91,8.08,8.08,0,0,1-.85-.05,13.24,13.24,0,0,1-2.12-.36,14.91,14.91,0,0,1-3.83-1.54,8,8,0,0,1-.74-.44,17.87,17.87,0,0,1-3.74-3.24c-.19-.21-.38-.43-.56-.65a26.17,26.17,0,0,1-2.75-4.15c-.14-.25-.28-.51-.4-.77a39.28,39.28,0,0,1-3.49-10.57l5.28-.3a40.19,40.19,0,0,0,3,7.08q.19.38.42.75a24.1,24.1,0,0,0,2.09,3c.18.23.37.45.56.66a12.75,12.75,0,0,0,2,1.83,6.54,6.54,0,0,0,.73.48,7.47,7.47,0,0,0,3,1.08l.3,0a8,8,0,0,0,.85,0,9.14,9.14,0,0,0,2.72-.55c.27-.09.53-.2.79-.31a15.92,15.92,0,0,0,2.57-1.42c.24-.15.47-.31.7-.48a30.42,30.42,0,0,0,3.07-2.58c.21-.19.42-.39.62-.6,1.1-1.08,2.14-2.24,3.1-3.39l.55-.66c1.05-1.29,2-2.55,2.8-3.68l.49-.69c1.48-2.14,2.36-3.64,2.36-3.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,301.73l-4.94,2.73s-3.95-8.1-2.39-15.22l8.8-2.2A32.24,32.24,0,0,1,312,301.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,303.85l-.46.71-6.59-3.87.49-.69Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63,308.83l-.53.67L337.77,305l.55-.66Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.47,313.58l-.61.6L334.05,309c.21-.19.42-.39.62-.6Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.58,317.74l-.71.48-4.59-6.14c.24-.15.47-.31.7-.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,320.27l-.8.29-3.26-6.75c.27-.09.53-.2.79-.31Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.41,321.47a8.08,8.08,0,0,1-.85-.05l-.21-7.07a8,8,0,0,0,.85,0Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,313.24l-2.43,6.28a8,8,0,0,1-.74-.44l2.44-6.32A6.54,6.54,0,0,0,320,313.24Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,310.93l-4.17,4.91c-.19-.21-.38-.43-.56-.65l4.17-4.92C316.92,310.5,317.11,310.72,317.3,310.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.65,307.23,309.82,311c-.14-.25-.28-.51-.4-.77l4.81-3.79Q314.43,306.86,314.65,307.23Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.23,295.63a1.28,1.28,0,0,1-1.31,1.46H312.45a1.68,1.68,0,0,1-1.63-1.46l-3.23-28.55a1.44,1.44,0,0,1,1.3-1.65h14.47a1.87,1.87,0,0,1,1.64,1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.4,266.89l3.27,28.83a1.1,1.1,0,0,1-1.14,1.37H313.26c-.82,0-2.33-.46-2.42-1.27l-3.28-28.93c-.09-.81,1.32-1.46,2.14-1.46H322A1.5,1.5,0,0,1,323.4,266.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.24,
    cy: 386.42,
    rx: 23.64,
    ry: 30.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.9,
    cy: 386.42,
    rx: 16.62,
    ry: 21.31,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.24,370.77l-18.46,19.39-59-2.7L324.4,372.9l8.25-19a3,3,0,0,1,2.77-1.82h14.83a3,3,0,0,1,2.21,1l.89,1,4.12,4.41a3,3,0,0,0,2.21,1H371.1a3,3,0,0,0,1.63-.47l9.91-6.34a3,3,0,0,1,1.62-.47H404.6a3,3,0,0,1,2.74,1.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.79,373l9.93-16.71a3.05,3.05,0,0,1,2.62-1.49h14.32a3,3,0,0,1,2.81,1.87l6.06,14.47-8.18,14.25-21.23-.79-6.33-12.39",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.64,352.54l-8.56,14.34a3.38,3.38,0,0,1-2.9,1.65H334a2.09,2.09,0,0,1-1.93-2.89l4.2-10.07a2.61,2.61,0,0,1,2.39-1.59h14.66l4.12,4.41a3,3,0,0,0,2.21,1H371.1a3,3,0,0,0,1.63-.47Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.05,404.15H337.28a9.09,9.09,0,0,1-6.94-3.22L320,388.68a9,9,0,0,1-2.13-5.84v-8.43a3.64,3.64,0,0,1,3.65-3.64h77.5a3.64,3.64,0,0,1,3.64,3.64v26.1A3.64,3.64,0,0,1,399.05,404.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,374.41v26.1a3.64,3.64,0,0,1-3.64,3.64H337.28a9.09,9.09,0,0,1-6.94-3.22L320,388.68a9,9,0,0,1-2.13-5.84v-8.43a3.64,3.64,0,0,1,3.65-3.64h77.5A3.64,3.64,0,0,1,402.69,374.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,374.41v26.1a3.64,3.64,0,0,1-3.64,3.64h-8.77a9.09,9.09,0,0,1-6.94-3.22L373,388.68a9,9,0,0,1-2.13-5.84v-8.43a3.64,3.64,0,0,1,3.65-3.64h24.5A3.64,3.64,0,0,1,402.69,374.41Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.87,404.15l-9.44-12.34a10.48,10.48,0,0,0-7.27-3.84,2.72,2.72,0,0,0-1.67.45h0l-.93.69h0c-.84.62-.81,1.84.27,3.25l9.35,12.22a2.13,2.13,0,0,0,1.69.83h9.48a1.28,1.28,0,0,0,1.28-1.25h-2.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.17,388.67h0c-2.3,0-2.9,1.65-1.34,3.68l9.35,12.22a2.13,2.13,0,0,0,1.69.83H348a1.74,1.74,0,0,1-1.39-.68l-9.5-12.37A10.07,10.07,0,0,0,330.17,388.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07,404.15l-9.44-12.34a10.46,10.46,0,0,0-7.27-3.84,2.72,2.72,0,0,0-1.67.45h0l-.93.69h0c-.84.62-.81,1.84.27,3.25l9.35,12.22a2.14,2.14,0,0,0,1.69.83h9.48a1.28,1.28,0,0,0,1.28-1.25h-2.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.37,388.67h0c-2.3,0-2.89,1.65-1.34,3.68l9.35,12.22a2.14,2.14,0,0,0,1.69.83h8.16a1.74,1.74,0,0,1-1.39-.68l-9.49-12.37A10.11,10.11,0,0,0,344.37,388.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,404.15l-9.44-12.34a10.46,10.46,0,0,0-7.27-3.84,2.74,2.74,0,0,0-1.67.45h0l-.93.69h0c-.84.62-.81,1.84.27,3.25l9.35,12.22a2.14,2.14,0,0,0,1.69.83h9.48a1.28,1.28,0,0,0,1.28-1.25h-2.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,388.67h0c-2.3,0-2.89,1.65-1.34,3.68l9.35,12.22a2.14,2.14,0,0,0,1.69.83h8.16a1.76,1.76,0,0,1-1.39-.68l-9.49-12.37A10.09,10.09,0,0,0,358.57,388.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.24,
    cy: 386.42,
    rx: 23.64,
    ry: 30.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.9,
    cy: 386.42,
    rx: 16.62,
    ry: 21.31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.06,395.14c-2.59,7.42-8.4,12.59-15.16,12.59-9.18,0-16.62-9.54-16.62-21.31,0-8.29,3.69-15.47,9.08-19a26.25,26.25,0,0,0-1.46,8.73c0,11.76,7.44,21.31,16.62,21.31A13.61,13.61,0,0,0,432.06,395.14Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.92,339.74v20.63a1.92,1.92,0,0,0,1.92,1.92h21.87a1.93,1.93,0,0,0,1.45-.67l7.21-8.34a3.5,3.5,0,0,1,2.65-1.21h2.92V339.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.94,339.74v12.33H385a3.45,3.45,0,0,0-2,.61,3.22,3.22,0,0,0-.68.6l-2.42,2.8-.74.85-2.93,3.4-.75.86-.37.43a1.93,1.93,0,0,1-1.45.67H351.84a1.93,1.93,0,0,1-1.74-1.1,2,2,0,0,1-.18-.82V339.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.92,
    y: 343.32,
    width: 38.02,
    height: 0.86,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.92,
    y: 347.57,
    width: 38.02,
    height: 0.86,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.94,351.83v.24H385a3.45,3.45,0,0,0-2,.61H349.92v-.85Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.95 356.08 379.21 356.93 349.92 356.93 349.92 356.08 379.95 356.08",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28,360.33l-.75.86H350.1a2,2,0,0,1-.18-.82v0Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.94,339.74v4.57c-5.95,1.5-23.22,5.55-38,6V339.74Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 276.91,
    width: 29.07,
    height: 16.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 276.91,
    width: 29.07,
    height: 16.08,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 282.47,
    width: 29.07,
    height: 0.8,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 285.98,
    width: 29.07,
    height: 0.8,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.31,
    y: 289.48,
    width: 29.07,
    height: 0.8,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.38,276.91V281c-7.4,2.65-19.64,6.41-29.07,6.07V276.91Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,231.11H344.56a11.12,11.12,0,0,0-11.12,11.12v28.49a11.12,11.12,0,0,0,11.12,11.11h50.85a11.12,11.12,0,0,0,11.12-11.11V242.23A11.12,11.12,0,0,0,395.41,231.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.53,242.23v28.49a11.11,11.11,0,0,1-11.12,11.11h-20a11.11,11.11,0,0,0,11.12-11.11V242.23a11.11,11.11,0,0,0-11.12-11.11h20A11.11,11.11,0,0,1,406.53,242.23Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.76,
    y: 236.02,
    width: 43.84,
    height: 40.9,
    rx: 6.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.53,
    y: 217.04,
    width: 1,
    height: 33.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,256.47a12.43,12.43,0,0,1-1.05,5,10.51,10.51,0,0,1-2,3.05,8.21,8.21,0,0,1-6,2.75c-5,0-9.06-4.85-9.06-10.85S395,245.62,400,245.62a8.31,8.31,0,0,1,6.06,2.77,10.67,10.67,0,0,1,2,3.05A12.53,12.53,0,0,1,409.1,256.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M403.17,264.26c-3.55,0-6.43-3.49-6.43-7.79s2.88-7.78,6.43-7.78a6,6,0,0,1,4.89,2.75,10.67,10.67,0,0,0-2-3.05,6.48,6.48,0,0,0-2.92-.7c-4.1,0-7.43,3.94-7.43,8.78s3.33,8.79,7.43,8.79a6.35,6.35,0,0,0,2.89-.69,10.51,10.51,0,0,0,2-3.05A6,6,0,0,1,403.17,264.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M370,250.18c0,1.76-.78,3.18-1.75,3.18s-1.76-1.42-1.76-3.18.79-3.18,1.76-3.18S370,248.42,370,250.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,250.16c0,1.76-.79,3.18-1.76,3.18s-1.75-1.42-1.75-3.18.78-3.18,1.75-3.18S351,248.4,351,250.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,264.93a53.4,53.4,0,0,1,4.81,6l1.22-.58c5.49-2.7,7.15-5.76,7.32-8.34a7.94,7.94,0,0,0-.72-3.67,7.69,7.69,0,0,0-1.1-1.83c-2.05,3.17-7,6.07-9.67,7.52C359.38,264.6,358.65,264.93,358.65,264.93Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.51,264l1.46,1.72c5.17-2.56,8.46-5,9.31-7.41a7.69,7.69,0,0,0-1.1-1.83C368.13,259.64,363.2,262.54,360.51,264Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,270.31c5.49-2.7,7.15-5.76,7.32-8.34a19.75,19.75,0,0,0-5.51,4.2A7.35,7.35,0,0,0,364.68,270.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.35,301.88v29.81a10.68,10.68,0,0,1-10.69,10.68H346.2a10.68,10.68,0,0,1-10.68-10.68V301.88A10.68,10.68,0,0,1,346.2,291.2h47.46A10.68,10.68,0,0,1,404.35,301.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.35,301.88v29.81a10.68,10.68,0,0,1-10.69,10.68H388.2a10.68,10.68,0,0,1-10.68-10.68V301.88A10.68,10.68,0,0,1,388.2,291.2h5.46A10.68,10.68,0,0,1,404.35,301.88Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.62 298.28 329.62 289.88 326.29 283.8 326.68 292.99 329.62 298.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.69,289l1.09-1.79,1.78-.93v-2.06l3.3-3.26,2.17,3.16L312,285l-1.29-.56-.25,1.47h1.66l1.62,4.73-1,.77.43,2.32-2.47,1.58-2.57-1,.65-1.59S304.69,293.09,304.69,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.82,298.35h0a4.58,4.58,0,0,1,4.32,6c-2.66,7.9-10.44,20.61-33,20.61-24.89,0-39.25-22.3-39.25-22.3l5.71-4.43s12.55,18.57,33.3,18.57c17.14,0,22.81-10.18,24.59-15.43A4.54,4.54,0,0,1,391.82,298.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,304.4a29.82,29.82,0,0,1-1.25,3.12c-.11.26-.23.52-.37.78a28.55,28.55,0,0,1-3,4.82,8.19,8.19,0,0,1-.53.67,27.22,27.22,0,0,1-5.77,5.29l-.71.48a31.29,31.29,0,0,1-6.87,3.28l-.82.27a41.18,41.18,0,0,1-7.7,1.58l-.85.09c-1.61.15-3.31.23-5.1.23-.85,0-1.68,0-2.5-.07l-.86-.07a41,41,0,0,1-6.65-1.1l-.84-.21a45,45,0,0,1-7.35-2.74l-.76-.38a48.68,48.68,0,0,1-6.76-4.09c-.24-.16-.47-.33-.7-.5a56.79,56.79,0,0,1-5.91-5l-.61-.6a51.39,51.39,0,0,1-6.31-7.52l5.71-4.43a44,44,0,0,0,5.54,6.33l.62.59a48.67,48.67,0,0,0,5,4.09c.23.17.46.34.7.5a44.08,44.08,0,0,0,5.91,3.44l.78.37a37.63,37.63,0,0,0,5.87,2.08c.27.08.55.15.83.21a34.13,34.13,0,0,0,5.47.86l.86.06c.57,0,1.15,0,1.74,0a38.81,38.81,0,0,0,4.44-.25c.29,0,.58-.07.86-.12A28.31,28.31,0,0,0,374,315.1l.81-.3a23.38,23.38,0,0,0,4.62-2.47c.24-.17.47-.33.69-.51a20.7,20.7,0,0,0,3.83-3.75c.19-.23.36-.46.52-.69a22.39,22.39,0,0,0,2.13-3.58c.12-.27.24-.53.35-.79.24-.56.44-1.1.61-1.59a4.57,4.57,0,0,1,8.63,3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,286.77s-5.58-3.7-6.07-3.5a46.33,46.33,0,0,0-3.86,3.47l.86,1.37-1.95,2.16.6.93L313,293.75l3.46,4.53h4.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,304l5.76-4.42s-4.47-12.25-5.76-12.83-9.07,6.15-9.07,7.21S321.91,302.33,324.84,304Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.89,307.52c-.11.26-.23.52-.37.78l-8-4.5c.12-.27.24-.53.35-.79Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.51,313.12a8.19,8.19,0,0,1-.53.67l-7.08-5.72c.19-.23.36-.46.52-.69Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,319.08l-.71.48-5.12-7.23c.24-.17.47-.33.69-.51Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,322.84l-.82.27-2.86-8,.81-.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,324.69l-.85.09-.9-8.18c.29,0,.58-.07.86-.12Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.18,316.81l-.52,8.13-.86-.07.52-8.12Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.85,315.89l-1.7,7.88-.84-.21,1.71-7.88C354.29,315.76,354.57,315.83,354.85,315.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,313.6,345,320.82l-.76-.38,3.17-7.21Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,309.79l-4,6.56c-.24-.16-.47-.33-.7-.5l4-6.56C341,309.46,341.22,309.63,341.46,309.79Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,305.2l-4.95,5.63-.61-.6,4.94-5.62Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatbot);
export default __webpack_public_path__ + "static/media/AI-Chatbot.342081d54fae4745f351c1a2f03c36d1.svg";
export { ForwardRef as ReactComponent };